<template>
  <div>
    <h1>Novo Concedente</h1>
    <b-card no-body>
      <Form @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import Form from "../Components/Form.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Form },
  computed: {
    ...mapState("concedentes", ["concedente"]),
  },
  methods: {
    ...mapActions("concedentes", ["ActionNew"]),
    loadData(id) {
      this.$router.push({ name: "concedentes_edit", params: { id: id } });
    },
  },
  async created() {
    this.ActionNew();
  },
};
</script>

<style></style>
